@switch (type) {
    @case ('regular') {
        <div class="switchers" [ngClass]="{ 'no-paddings': noPaddings, 'no-margin': noMargin }" data-crlat="switchers">
            @for (switcher of switchers; track switcherIndex; let switcherIndex = $index) {
                <a
                    class="switch-btn"
                    [ngClass]="{ active: isActive(switcher), filled: switcher.filled, overlay: isOverlay, disabled: isOverlay && switcher.selected }"
                    (click)="switcher.onClick(switcher.viewByFilters); detectActiveTab(switcher)"
                    data-crlat="buttonSwitch">
                    <span [textContent]="getTabName(switcher)" data-crlat="switcher.name"></span>
                    @if (switcher.eventCount) {
                        <span class="switch-btn-bind" [innerHTML]="switcher.eventCount" data-crlat="switcher.eventCount"></span>
                    }
                    @if (switcher.icon) {
                        <ng-content></ng-content>
                    }
                </a>
            }
        </div>
    }

    @case ('scrollable') {
        <div class="switchers scrollable-switchers" [ngClass]="{ 'no-paddings': noPaddings, 'no-margin': noMargin }" data-crlat="switchers">
            <div
                class="scroll-container"
                scrollable
                scrollonce
                [scrollonce]="GATrackingModule"
                [GATrackingObj]="GTMTrackingObj"
                [rescrollOnChange]="activeTab?.id">
                <ul class="scroll-inner" [ngClass]="{ 'auto-sizable-switchers': isAutoSizable() }">
                    @for (switcher of switchers; track switcherIndex; let switcherIndex = $index) {
                        @if (!switcher.hidden) {
                            <li>
                                <a
                                    class="switch-btn"
                                    [ngClass]="{
                                        active: isActive(switcher, switcherIndex),
                                        filled: switcher.filled,
                                    }"
                                    (click)="clickFunction(switcher, $event, switcherIndex + 1)"
                                    [attr.href]="switcher.url"
                                    [vnSpeculativeLink]="switcher.url"
                                    data-crlat="buttonSwitch">
                                    <span class="switch-text" data-crlat="switcher.name" [ngClass]="{ 'tab-byb-icon': switcher.bybAvb === true }">
                                        @if (switcher.bybAvb) {
                                            <svg class="byb-label">
                                                <use xlink:href="#tab-byb-icon"></use>
                                            </svg>
                                        }
                                        {{ getTabName(switcher) }}
                                        @if (switcher.showNewFlag) {
                                            <span>
                                                <svg data-crlat="new-icon-popular" class="new-icon-popular">
                                                    <use [attr.xlink:href]="'#icn-new-popular_bets'"></use>
                                                </svg>
                                            </span>
                                        }
                                    </span>
                                    @if (switcher.eventCount) {
                                        <span class="switch-btn-bind" [innerHTML]="switcher.eventCount" data-crlat="switcher.eventCount"></span>
                                    }
                                </a>
                            </li>
                        }
                    }
                </ul>
            </div>
        </div>
    }

    @case ('links') {
        <div class="switchers" [ngClass]="{ 'no-paddings': noPaddings, 'no-margin': noMargin }" data-crlat="switchers">
            @for (switcher of switchers; track switcherIndex; let switcherIndex = $index) {
                <a
                    class="switch-btn"
                    [ngClass]="{ active: filter === switcherIndex }"
                    (click)="switcher.onClick(switcherIndex); detectActiveTab(switcher)"
                    data-crlat="buttonSwitch"
                    [textContent]="getTabName(switcher)">
                </a>
            }
        </div>
    }
}
